import { Box, IconButton, Toolbar, Tooltip, Typography } from '@mui/material'
import { DownloadIcon, FullScreenIcon, SearchIconBtn } from '../assets/icons/index.js'
import { CommonTable, CommonTabs, Search } from '../components/common/index.js'
import PageHeader from '../components/common/PageHeader'
import Layout from '../components/layout/Layout'
import KeyFilter from '../components/Returns/Define/common/KeyFilter.jsx'
import { GLOBAL_CONSTANTS } from '../constants/globalConstants'
import {
  PROVISION_COLUMNS,
  PROVISION_SEARCH_FIELDS,
} from '../constants/provision.js'
import { useProvision } from '../hooks/useProvision.js'

const Provision = () => {
  const {
    tabs,
    activeTabIndex,
    isFullScreen,
    searchOpen,
    searchCriteria,
    anchorEl,
    totalItems,
    itemsPerPage,
    currentPage,
    tableData,
    loading,
    expandedRows,
    showTable,
    handleRowExpand,
    handleTabChange,
    handleViewClick,
    handleFullscreen,
    handleFullScreenExit,
    handleExcelDownload,
    handleSearch,
    handleCloseSearch,
    handleApplySearch,
    handleResetSearch,
    setSearchCriteria,
    handlePageChange,
    handleItemsPerPageChange,
  } = useProvision()
  return (
    <Layout>
      {!isFullScreen && (
        <>
          <PageHeader
            title={GLOBAL_CONSTANTS.PROVISION_ADVANCE_HEADING}
            padding="px-2 py-4"
          />
          <Box sx={{ mt: 2 }}>
            <CommonTabs
              tabs={tabs}
              activeIndex={activeTabIndex}
              onTabChange={handleTabChange}
            />
          </Box>

          <KeyFilter
            key={activeTabIndex}
            handleViewClick={handleViewClick}
            isStatus={true}
            isYear={true}
          />
        </>
      )}

      {showTable && (
        <>
          <Toolbar sx={{ justifyContent: 'space-between' }} disableGutters>
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontSize: 'var(--heading-font-size)',
                color: 'var(--heading-grey)',
                fontWeight: 'var(--heading-font-weight)',
                fontFamily: 'var(--heading-font-family)',
              }}
            >
              {activeTabIndex === 0
                ? GLOBAL_CONSTANTS.PROVISIONS
                : GLOBAL_CONSTANTS.ADVANCES}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Tooltip
                title={
                  !isFullScreen
                    ? GLOBAL_CONSTANTS.FULL_SCREEN_TOOLTIP
                    : GLOBAL_CONSTANTS.EXIT_FULL_SCREEN_TOOLTIP
                }
              >
                <IconButton
                  size="small"
                  sx={{ color: 'var(--forbrand-primary)' }}
                  onClick={
                    !isFullScreen ? handleFullscreen : handleFullScreenExit
                  }
                >
                  {!isFullScreen ? <FullScreenIcon /> : <FullScreenIcon />}
                </IconButton>
              </Tooltip>
              <Tooltip title={GLOBAL_CONSTANTS.DOWNLOAD_EXCEL}>
                <IconButton
                  sx={{
                    color: 'var(--forbrand-primary)',
                  }}
                  onClick={handleExcelDownload}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={GLOBAL_CONSTANTS.SEARCH}>
                <IconButton
                  sx={{
                    color: 'var(--forbrand-primary)',
                  }}
                  onClick={handleSearch}
                >
                  <SearchIconBtn />
                </IconButton>
              </Tooltip>
            </Box>
          </Toolbar>

          <CommonTable
            showFooter={true}
            showItemsPerPage={true}
            showTotalItems={true}
            showPageNumbers={true}
            showActions={false}
            showExpandColumn={true}
            columns={PROVISION_COLUMNS}
            data={tableData}
            loading={loading}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            currentPage={currentPage}
            expandedRows={expandedRows}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
            onRowExpand={handleRowExpand}
            emptyMessage="No data found"
          />

          <Search
            placement="bottom-start"
            open={searchOpen}
            searchCriteria={searchCriteria}
            anchorEl={anchorEl}
            fields={PROVISION_SEARCH_FIELDS}
            onClose={handleCloseSearch}
            onApply={handleApplySearch}
            onReset={handleResetSearch}
            setSearchCriteria={setSearchCriteria}
          />
        </>
      )}
    </Layout>
  )
}

export default Provision
